import { useEffect, useState } from 'react';
import { api, ApiError } from './api/client.js';
import { cacheGet, cachePut } from './offline/db.js';

// Who is signed in and what they may do. The last good answer is kept on the
// device so the app opens with no signal; the server copy replaces it when
// reachable. Roles changed in Entra apply on the next online open.
export function useMe(accountId) {
  const [state, setState] = useState({ me: null, status: 'loading' });

  useEffect(() => {
    if (!accountId) return undefined;
    let live = true;
    const key = `me:${accountId}`;
    (async () => {
      const cached = await cacheGet(key);
      if (cached && live) setState({ me: cached, status: 'ready' });
      try {
        const me = await api('/me');
        await cachePut(key, me);
        if (live) setState({ me, status: 'ready' });
      } catch (e) {
        if (!live) return;
        if (e instanceof ApiError && e.status === 403) setState({ me: null, status: 'no-access' });
        else if (!cached) setState({ me: null, status: e.code === 'offline' ? 'offline' : 'error' });
      }
    })();
    return () => { live = false; };
  }, [accountId]);

  return state;
}
